/* Copyright (c) 2024 Xperi. All Rights Reserved. */

/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum PlaybackRestrictionType {
    ADULT,
    APP_BACKGROUND,
    APP_FOREGROUND,
    BLACKLISTED,
    DEVICE_RESTRICTED,
    INHOME_LOCATION_ERROR,
    INHOME_LOCATION_UNREACHABLE,
    NETWORK_CONNECTED,
    NETWORK_DISCONNECTED,
    NO_RESTRICTION,
    OUT_OF_HOME,
    OUT_OF_REGION,
    UNSUBSCRIBED,
}
